module.exports = __webpack_public_path__ + "img/second_appointment_button1.add16f5f.png";